"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var editorjs_1 = __importDefault(require("@editorjs/editorjs"));
var editorjs_drag_drop_1 = __importDefault(require("editorjs-drag-drop"));
var components_1 = require("@/components");
var i18n_1 = __importDefault(require("./i18n"));
var utils_1 = require("@/utils");
var tools_1 = __importDefault(require("./tools"));
var Editor = function (_a) {
    var _b;
    var id = _a.id, savedData = _a.savedData;
    var editorRef = (0, react_2.useRef)();
    var _c = __read((0, react_2.useState)(savedData), 2), editorData = _c[0], setEditorData = _c[1];
    var _d = __read((0, react_2.useState)(false), 2), editorReady = _d[0], setEditorReady = _d[1];
    var getEditorContent = function () { return __awaiter(void 0, void 0, Promise, function () {
        var _a;
        return __generator(this, function (_b) {
            return [2 /*return*/, (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.saver.save()];
        });
    }); };
    var initEditor = function () {
        var editor = new editorjs_1.default({
            holder: id,
            data: editorData,
            onReady: function () {
                editorRef.current = editor;
                // eslint-disable-next-line no-new
                new editorjs_drag_drop_1.default(editor);
                setEditorReady(true);
            },
            onChange: function () { return __awaiter(void 0, void 0, void 0, function () {
                var editorContent;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, getEditorContent()];
                        case 1:
                            editorContent = _a.sent();
                            (0, utils_1.setLocalStorageData)(id, editorContent);
                            setEditorData(editorContent);
                            return [2 /*return*/];
                    }
                });
            }); },
            autofocus: true,
            // @ts-expect-error: third party plugin
            tools: tools_1.default,
            i18n: i18n_1.default,
        });
    };
    (0, react_2.useEffect)(function () {
        if (!editorRef.current)
            initEditor();
        return function () {
            var _a;
            (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        };
    }, []);
    (0, react_2.useEffect)(function () {
        if (!editorRef.current)
            return;
        var newEditorData = (savedData === null || savedData === void 0 ? void 0 : savedData.blocks) ? savedData : (0, utils_1.getDefaultEditorData)();
        setEditorData(newEditorData);
        editorRef.current.render(newEditorData);
        (0, utils_1.setLocalStorageData)(id, newEditorData);
    }, [editorReady, savedData]);
    /** Tab을 입력했을 때 에디터 밖으로 TabIndex가 변경되는 것을 방지 */
    (0, react_2.useEffect)(function () {
        var _a, _b;
        var isEditorFocused = ((_b = (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.getCurrentBlockIndex()) !== -1;
        var handleKeyDown = function (event) {
            if (isEditorFocused && event.key === 'Tab') {
                event.preventDefault();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { id: id }, void 0), ";", (0, jsx_runtime_1.jsx)(components_1.Blocker, { isBlocking: ((_b = editorData === null || editorData === void 0 ? void 0 : editorData.blocks) === null || _b === void 0 ? void 0 : _b.length) !== 0 }, void 0)] }, void 0));
};
exports.default = Editor;
